import { type SupportedLanguage } from '@/lib/user-language'
import {
  EMAIL_APP_NAME,
  EMAIL_APP_NAME_HTML,
  renderEmailLayout,
  renderFallbackLink,
  renderPrimaryEmailButton,
} from '@/lib/email-template'

export function buildMagicLinkEmail(url: string, host: string, language: SupportedLanguage = 'en'): { subject: string; html: string; text: string } {
  const copy = language === 'es'
    ? {
        subject: `Tu enlace de inicio de sesion para ${EMAIL_APP_NAME}`,
        heading: `Inicia sesion en ${EMAIL_APP_NAME_HTML}`,
        body: `Haz clic en el boton de abajo para iniciar sesion. Este enlace es valido por <strong>10 minutos</strong> y solo puede usarse una vez.`,
        cta: `Iniciar sesion en ${EMAIL_APP_NAME}`,
        fallbackTitle: '¿El boton no funciona?',
        fallbackText: 'Pega este enlace en tu navegador:',
        ignore: 'Si no solicitaste este correo, puedes ignorarlo de forma segura. Alguien pudo haber ingresado tu correo por error.',
        text: `Inicia sesion en ${EMAIL_APP_NAME}\n\nHaz clic en el enlace de abajo para iniciar sesion. Este enlace es valido por 10 minutos.\n\n${url}\n\nSi no solicitaste esto, puedes ignorar este correo de forma segura.\n\n- ${EMAIL_APP_NAME} / ${host}`,
      }
    : {
        subject: `Your sign-in link for ${EMAIL_APP_NAME}`,
        heading: `Sign in to ${EMAIL_APP_NAME_HTML}`,
        body: `Click the button below to sign in. This link is valid for <strong>10 minutes</strong> and can only be used once.`,
        cta: `Sign in to ${EMAIL_APP_NAME}`,
        fallbackTitle: 'Button not working?',
        fallbackText: 'Paste this link into your browser:',
        ignore: `If you didn&rsquo;t request this email, you can safely ignore it. Someone may have entered your email address by mistake.`,
        text: `Sign in to ${EMAIL_APP_NAME}\n\nClick the link below to sign in. This link is valid for 10 minutes.\n\n${url}\n\nIf you didn't request this, you can safely ignore this email.\n\n— ${EMAIL_APP_NAME} / ${host}`,
      }

  const subject = copy.subject

  const html = renderEmailLayout({
    subject,
    language,
    footerUrl: `https://${host}`,
    footerLabel: host,
    contentHtml: `<tr>
                  <td style="padding-bottom:8px;">
                    <p style="margin:0;font-size:22px;font-weight:700;color:#18181b;letter-spacing:-0.4px;">${copy.heading}</p>
                  </td>
                </tr>

                <tr>
                  <td style="padding-bottom:28px;">
                    <p style="margin:0;font-size:15px;line-height:1.6;color:#52525b;">
                      ${copy.body}
                    </p>
                  </td>
                </tr>
                ${renderPrimaryEmailButton({ href: url, label: copy.cta, letterSpacing: true })}
                ${renderFallbackLink({ href: url, title: copy.fallbackTitle, text: copy.fallbackText })}
                <tr>
                  <td>
                    <p style="margin:0;font-size:12px;color:#a1a1aa;line-height:1.5;">
                      ${copy.ignore}
                    </p>
                  </td>
                </tr>`,
  })

  const text = copy.text

  return { subject, html, text }
}
